import React from "react";

import bg from "../../static/img/backgrounds/user-lock-2.svg";
import ic from "../../static/img/backgrounds/user-lock.svg";

class Error403 extends React.Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
					<div>
					<div className="error__sect" style={{backgroundImage: `url(${bg})`}}>
						<div className="error-content">
							<div className="flexbox"><span className="error-icon" style={{backgroundImage: `url(${ic})`}} />
								<div className="flex-1">
									<h1 className="error-code">403</h1>
									<h3 className="font-strong">FORBIDDEN</h3>
									<p className="text-center mb-3 mt-5">Bạn không có quyền truy cập vào trang web. Vui lòng liên hệ hotline 1900 9217 (T2-T7 9AM-6PM). Hoặc để lại tin nhắn cho Mioto qua <a href="https://www.facebook.com/mioto.vn" >Fanpage</a></p>
								</div>
							</div>
						</div>
					</div>
				</div>
        );
    }
}

export default Error403;


// WEBPACK FOOTER //
// ./src/components/login/error403.js